export const NUMGNUM_NAMES = [
  "",
  "NibbleWick",
  "DuoBite",
  "Chompley",
  "Snurl",
  "Numnivorous",
  "Jittergnash",
  "Yumbler",
  "Gobgrin",
  "Numgnaw",
] as const;

export type Edition = "arcade" | "midnight" | "coastal" | "library";

const padded = (level: number) => String(level).padStart(2, "0");
const slug = (level: number) => NUMGNUM_NAMES[level]?.toLowerCase() ?? `numgnum-${level}`;

export function cardFront(level: number, edition: Edition, founder = false) {
  const safeLevel = Math.min(Math.max(level, 1), 9);
  if ((edition === "arcade" || edition === "midnight") && founder) {
    return `/art/cards/${edition}/founder/${padded(safeLevel)}-${slug(safeLevel)}-founder.webp`;
  }
  if (edition === "arcade" || edition === "midnight") {
    return `/art/cards/${edition}/regular/${padded(safeLevel)}-${slug(safeLevel)}-regular.webp`;
  }
  return `/art/cards/${edition}/regular/${slug(safeLevel)}.webp`;
}

export function cardBack(edition: Edition, founder = false) {
  const artEdition = edition === "midnight" ? "midnight" : "arcade";
  return `/art/cards/backs/${artEdition}-${founder ? "founder" : "regular"}-back.webp`;
}

export const demoCards = [
  { level: 1, edition: "arcade" as Edition, is_shiny: false, serial_number: 47, is_founder: false, founder_username: "Thatcher" },
  { level: 3, edition: "midnight" as Edition, is_shiny: true, serial_number: 18, is_founder: false, founder_username: "Jocelyn" },
  { level: 5, edition: "arcade" as Edition, is_shiny: false, serial_number: 1, is_founder: true, founder_username: "Beachcomber" },
  { level: 6, edition: "midnight" as Edition, is_shiny: false, serial_number: 1, is_founder: true, founder_username: "TideRider" },
  { level: 8, edition: "arcade" as Edition, is_shiny: false, serial_number: 63, is_founder: false, founder_username: "Thatcher" },
];
